module.exports = __webpack_public_path__ + "img/quadradoVerde.fed6feaa.png";